<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="frontmatter_copyright">First American edition published in 2019 by Carolrhoda Books</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_copyright">Text copyright © 2018 by Jeremy Lachlan</p>
<p class="frontmatter_copyright">First published in 2018 by Hardie Grant Egmont</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_copyright">All US rights reserved. No part of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopying, recording, or otherwise—without the prior written permission of Lerner Publishing Group, Inc., except for the inclusion of brief quotations in an <span class="no-break">acknowledged review</span>.</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_publisher-info">Carolrhoda Books</p>
<p class="frontmatter_publisher-info">A division of Lerner Publishing Group, Inc.</p>
<p class="frontmatter_publisher-info">241 First Avenue North</p>
<p class="frontmatter_publisher-info">Minneapolis, MN 55401 USA</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_publisher-info">For reading levels and more information, look up this title at <a href="http://www.lernerbooks.com" target="_blank"><span class="no-break"><span class="backmatter_URL">www.lernerbooks.com</span></span></a>.</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_acknowledgments-and-credits">Cover illustration by Iacopo Bruno.</p>
<p class="frontmatter_acknowledgments-and-credits">Photo of columns: AndresGarciaM/Getty Images.</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_acknowledgments-and-credits">Main body text set in Bembo Std regular 12.5/17.</p>
<p class="frontmatter_acknowledgments-and-credits">Typeface provided by Monotype Typography.</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_CIP"><span class="frontmatter_emphasis _idGenCharOverride-2">Library of Congress Cataloging-in-Publication Data</span></p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_CIP">Names: Lachlan, Jeremy, author.</p>
<p class="frontmatter_CIP">Title: Jane Doe and the cradle of all worlds / Jeremy Lachlan.</p>
<p class="frontmatter_CIP">Description: Minneapoli<span class="no-break">s :</span> Carolrhoda Books, [2019<span class="no-break">] |</span> Originally published: Sydney, Australi<span class="no-break">a :</span> Hardie Grant Egmont, 2018<span class="no-break">. |</span> Summary: “Jane Doe and her father, John, appeared on the steps of the Manor the night the earthquakes started and the gateway to the Otherworlds closed. Fourteen years later, Jane enters the Manor to save her missing father . . . and the world” —Provided by publisher. </p>
<p class="frontmatter_CIP">Identifiers: <span class="no-break">LCCN 2</span>018033080 (print<span class="no-break">) |</span> <span class="no-break">LCCN 2</span>018038644 (ebook<span class="no-break">) |</span> <span class="no-break">ISBN </span><span class="no-break"><span class="frontmatter_ISBN">9</span></span><span class="frontmatter_ISBN">781541541771</span> (eb pdf<span class="no-break">) |</span> <span class="no-break">ISBN </span><span class="no-break"><span class="frontmatter_ISBN">9</span></span><span class="frontmatter_ISBN">781541539211</span> (t<span class="no-break">h :</span> alk. paper)</p>
<p class="frontmatter_CIP">Subjects<span class="no-break">: |</span> CYAC: Missing persons—Fiction<span class="no-break">. |</span> Adventure and adventurers—Fiction<span class="no-break">. |</span> Fantasy.</p>
<p class="frontmatter_CIP">Classification: <span class="no-break">LCC P</span>Z7.1.L214 (ebook<span class="no-break">) |</span> <span class="no-break">LCC P</span>Z7.1.L214 Jan 2019 (print<span class="no-break">) |</span> DDC [Fic]—dc23</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_CIP">LC record available at <a href="https://lccn.loc.gov/2018033080" target="_blank"><span class="backmatter_URL">https://lccn.loc.gov/2018033080</span></a></p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_manufacturing-info">Manufactured in the United States of America</p>
<p class="frontmatter_manufacturing-info">1-45123-35938-9/24/2018</p>
<p class="PageBreak"> </p>
<div class="centerfull">
<img alt="" id="_idDedication" src="image/dedication.gif"/>
</div>
<p class="PageBreak"> </p>
<div class="centerfull">
<img alt="" id="_idParaDest-1" src="image/epigraph.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// x9781541541771-2.vue?e1f298ba